import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "./style.css";
import potatoChips from "../../../assets/potato-chips.png";
import chips from "../../../assets/chips.png";

function Header({ data }) {
	const lang = useSelector((state) => state?.lang?.lang);
	const { t } = useTranslation();

	return (
		<div className="header-home">
			<motion.img
				src={chips}
				animate={{ scale: [1, 1.1, 0.9, 1] }}
				transition={{
					duration: 2,
					repeat: Infinity,
					ease: "easeInOut",
				}}
				alt="chips"
				className="chips1"
			/>
			<motion.img
				src={chips}
				animate={{ scale: [1, 1.2, 1, 0.9, 1] }}
				transition={{
					duration: 3,
					repeat: Infinity,
					ease: "easeInOut",
				}}
				alt="chips"
				className="chips2"
			/>
			<div className="container h-100">
				<Swiper
					slidesPerView={1}
					modules={[Autoplay]}
					autoplay={{
						delay: 3500,
						disableOnInteraction: false,
					}}
					loop={true}
					style={{ direction: "ltr" }}
					className="mySwiper h-100">
					{data?.map((res, index) => {
						return (
							<SwiperSlide key={index}>
								<Row className="h-100 mobile-order w-100">
									<Col md={6} className="header-img">
										<img src={res?.image} alt="slide" />
									</Col>
									<Col md={6}>
										<div className="header-text">
											<motion.img
												src={potatoChips}
												alt="potatoChips"
												className="potatoChips"
												height={80}
												width={80}
												animate={{
													scale: [1, 1.1, 0.9, 1],
													rotate: [0, 15, -15, 0],
												}}
												transition={{
													duration: 3,
													repeat: Infinity,
													ease: "easeInOut",
												}}
											/>
											<motion.p
												initial={{ opacity: 0 }}
												animate={{ opacity: 1 }}
												transition={{ delay: 0.25, duration: 1 }}
												className="title">
												{lang === "en" ? res?.title_en : res?.title_ar}
											</motion.p>
											<motion.p
												initial={{ opacity: 0 }}
												animate={{ opacity: 1 }}
												transition={{ delay: 0.25, duration: 1 }}
												className="description">
												{lang === "en"
													? res?.description_en
													: res?.description_ar}
											</motion.p>
											<Link to="/our-products">{t("Shop Now")}</Link>
										</div>
									</Col>
								</Row>
							</SwiperSlide>
						);
					})}
				</Swiper>
			</div>
		</div>
	);
}

export default Header;
